<template>
  <overview-table
    title="Reservas em Andamento"
    :headers="headers"
    :items="items"
    :footers="[footer]"
  >
    <template #no-data>
      <h4>Não existem reservas ativas no momento para este evento.</h4>
    </template>
  </overview-table>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type Overview from '@/types/Overview'
import OverviewTable from './partials/OverviewTable.vue'

const { overview } = defineProps<{ overview: Overview }>()

const items = computed(() => overview.reservations)

const headers = ref([
  { key: 'sector_name', value: 'sector_name', title: 'Setor', sortable: false },
  { key: 'ticket_type_name', value: 'ticket_type_name', title: 'Tipo', sortable: false },
  { key: 'total', value: 'total', title: 'Processando', sortable: true },
])

const footer = computed(
  () => ({
    sector_name: 'Total',
    total: items.value.reduce((acc, curr) => acc + curr.total, 0),
  }),
)

</script>
